import { render } from "./BookDetailsHeader.vue?vue&type=template&id=63cc9b8d&scoped=true"
import script from "./BookDetailsHeader.vue?vue&type=script&lang=js"
export * from "./BookDetailsHeader.vue?vue&type=script&lang=js"

import "./BookDetailsHeader.vue?vue&type=style&index=0&id=63cc9b8d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cc9b8d"]])

export default __exports__